














































import { Component, Prop, Vue, Watch } from "vue-property-decorator";

export interface QuadrantChartLabels {
  rightLabel: string;
  leftLabel: string;
  topLabel: string;
  bottomLabel: string;
}

export interface QuadrantChartItem {
  label: string;
  xPercentage: number;
  yPercentage: number;
}

@Component
export default class QuadrantChart extends Vue {
  @Prop({ required: true }) readonly labels!: QuadrantChartLabels;
  @Prop({ required: true }) readonly items!: QuadrantChartItem[];
  @Prop({ default: 0 }) readonly xMin!: number;
  @Prop({ default: 0 }) readonly yMin!: number;
  @Prop({ default: 100 }) readonly xMax!: number;
  @Prop({ default: 100 }) readonly yMax!: number;

  private paletteColors = [
    "#006CFF",
    "#FFC834",
    "#00FF9D",
    "#FF3939",
    "#A700FF",
    "#5AD9FF",
    "#E87F18",
    "#29B26E",
    "#FF62AB",
    "#AEA9E0",
    "#C1EAED",
    "#FFE89B",
    "#84A286",
    "#FFB1CF",
    "#805D8E",
    "#196986",
    "#763B00",
    "#155D15",
    "#950000",
    "#501D62",
  ];
  private circleItemSize = 20;

  mounted() {}

  getChartItemClassStyle(item: QuadrantChartItem, index: number) {
    let left = 0;
    let top = 0;

    if (this.xMin === this.xMax) {
      left = 50;
    } else {
      left = ((item.xPercentage - this.xMin) / (this.xMax - this.xMin)) * 100;
    }
    if (this.yMin === this.yMax) {
      top = 50;
    } else {
      top = ((item.yPercentage - this.yMin) / (this.yMax - this.yMin)) * 100;
    }

    return {
      left: `calc(${left}% - ${this.circleItemSize / 2}px)`,
      top: `calc(${top}% - ${this.circleItemSize / 2}px)`,
      backgroundColor: `${this.paletteColors[this.getRightIndexColor(index)]}`,
    };
  }

  getListItemClassStyle(item: QuadrantChartItem, index: number) {
    return {
      backgroundColor: `${this.paletteColors[this.getRightIndexColor(index)]}`,
    };
  }

  getRightIndexColor(index: number) {
    if (index + 1 > this.paletteColors.length) {
      const module = (index + 1) % this.paletteColors.length;
      index = module;
    }

    return index;
  }
}
